import React, {useRef, useState} from 'react';
import { CheckIcon } from '@heroicons/react/solid';

const Hp = (props) => {
  const inputRef = useRef(null);
  const [hp, setHp] = useState(props.character.currentHp)
  const [dirty, setDirty] = useState(false)

  const confirm = () => {
    const cleanValue = String(hp).replace(/(\D)/gm, "");
    const value = cleanValue === '' ? props.character.currentHp : cleanValue;
    setHp(value);
    setDirty(false);
    props.updateValue(value);
  };

  if (props.inline) {
    return (
      <div className='hpInline' onClick={() => inputRef.current.focus()}>
        <input
          ref={inputRef}
          value={hp}
          type="number"
          min={0}
          max={999}
          onChange={(e) => { setHp(e.target.value); setDirty(true); }}
          onKeyDown={(e) => { if (e.key === 'Enter') confirm(); }}
        />
        <span className='hpSep'>/</span>
        <span className='hpMax'>{props.character.maxHp}</span>
        {dirty && (
          <button className='hpConfirmBtn' onClick={(e) => { e.stopPropagation(); confirm(); }}>
            <CheckIcon style={{ width: 14, height: 14 }} />
          </button>
        )}
      </div>
    );
  }

  return (
    <div className='hpCharacter' onClick={() => inputRef.current.focus()}>
      <input
        ref={inputRef}
        value={hp}
        type="number"
        min={0}
        max={999}
        onChange={(e) => {
          setHp(e.target.value);
          setDirty(true);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') confirm();
        }}
      />
      <span>{` / `}</span>
      <span>{props.character.maxHp}</span>
      {dirty && (
        <button className='hpConfirmBtn' onClick={(e) => { e.stopPropagation(); confirm(); }}>
          <CheckIcon style={{ width: 14, height: 14 }} />
        </button>
      )}
      <div className='hpBar' style={{width: `${(props.character.currentHp * 100) / props.character.maxHp}%`}}/>
      <div className='hpBarEmpty'/>
    </div>
  );

}

export default Hp
